module.exports = "/_next/static/images/award-Warta-ekonomi-cc0e027bc9e0bd36fd3bf2bd51fe4924.png";